import { LayoutProps, rankWith, uiTypeIs } from "@jsonforms/core";
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import { getElements, getLabel } from "../../../../../utils/DynamicForms";
import { useDynamicFormContext } from "../../../DynamicFormContext";
import "./style.scss";

type Props = LayoutProps;

const SummaryLayout = (props: Props) => {
  const { formData } = useDynamicFormContext();
  const getElementByType = (type: string) =>
    getElements(props.uischema).find((el) => el.type === type) || ({} as any);

  const isStatic = props?.uischema?.options?.static;
  if (!props.visible) return null;

  if (!formData?.quoteHasPremium && !isStatic) {
    return (
      <div className="tru-list-loading">
        <span className="loading-anim"></span>
      </div>
    );
  }

  return (
    <div className="tru-layout-pricing-gk">
      <div className="layout-info-and-prices-comparison-gk">
        {!isStatic && <h5 className="title"> {getLabel(props.uischema)} </h5>}
        <div className="prices-comparison-gk">
          {!isStatic && (
            <div className="price-info-gk">
              {
                <ResolvedJsonFormsDispatch
                  {...props}
                  uischema={getElementByType("PremiumHeader")}
                />
              }
              <div className="quote-actions-gk"></div>
            </div>
          )}
          <div className="quote-finalstep-gk quote-actions">
            {getElements(props.uischema)
              .filter((element) => element.type === "DisplayInput")
              .map((el, index) => (
                <ResolvedJsonFormsDispatch
                  {...props}
                  uischema={el}
                  key={index}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const SummaryLayoutEntry = {
  tester: rankWith(1, uiTypeIs("SummaryLayout")),
  renderer: withJsonFormsLayoutProps(SummaryLayout),
};
